(function verticalSwiper(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  const previousVerticalSwiper = global.NewHomeSource.VerticalSwiper;

  /**
  * @private
  * movementX: returns the clientY coordinate of the mouse or touch event.
  *
  * @param {event} event with the information of the mouse or touch event.
  */
  function movementY(event) {
    return event.changedTouches
      ? event.changedTouches[0].clientY
      : event.clientY;
  }

  /**
  * @private
  * moveElement: move the element vertical.
  */
  function moveElement(updateTransitionY, translate) {
    const element = this.element;
    element.style.transitionDuration = '0.7s';
    this.update(updateTransitionY);
    this.translate(translate);
  }

  /**
   * @private
   * validate: validates the translation movement does not go outside bounds.
   */
  function validate() {
    const element = this.element;
    const availableHeight = element.parentElement.getBoundingClientRect().height;
    const totalHeight = element.getBoundingClientRect().height;
    const maximum = availableHeight - totalHeight;

    if (totalHeight <= availableHeight) {
      moveElement.call(this, 0, 0);
      return;
    }

    if (this.translateY > 0) {
      moveElement.call(this, this.translateY, -this.translateY);
      return;
    }

    if (this.translateY < maximum) {
      moveElement.call(this, 0, maximum);
    }
  }

  /**
  * @private
  * onTouchEnd: handler of mouse up and touch end events.
  *
  * @param {event} event with the information of the mouse or touch event.
  */
  function onTouchEnd(event) {
    const totalMovement = Math.abs(movementY(event) - this.touchStart);

    this.isClick = totalMovement > 10;
    this.touchNow = null;
    this.touchStart = null;

    if (!this.isClick) {
      return;
    }

    requestAnimationFrame(validate.bind(this));
  }

  /**
  * @private
  * onTouchMove: handler of mouse and touch move events.
  *
  * @param {event} event with the information of the mouse or touch event.
  */
  function onTouchMove(event) {
    const clientY = movementY(event);
    const translation = clientY - this.touchNow;

    event.preventDefault();

    if (!this.isScrolling()) {
      return;
    }

    this.touchNow = clientY;
    this.translate(translation);
  }

  /**
  * @private
  * onTouchStart: handler of mouse down and touch start events.
  *
  * @param {event} event
  */
  function onTouchStart(event) {
    const clientY = movementY(event);

    this.element.style.transitionDuration = '';
    this.touchStart = clientY;
    this.touchNow = clientY;
    this.isClick = true;
  }

  /**
  * @private
  * onWheel: handler of when user move wheel in the element.
  *
  * @param {event} event
  */
  function onWheel(event) {
    const value = (this.scrollCallback && this.scrollCallback(event.deltaY)) || 0;
    this.translate(value);
  }

  /**
   * @constructs NewHomeSource.VerticalSwiper
   */
  function VerticalSwiper(element, callback, scrollElement, scrollCallback) {
    if (!element) {
      return;
    }

    this.translateY = 0;
    this.callback = callback;
    this.scrollCallback = scrollCallback;
    this.element = element;
    this.element.addEventListener('mousedown', onTouchStart.bind(this), false);
    this.element.addEventListener('touchstart', onTouchStart.bind(this), false);
    this.element.addEventListener('mousemove', onTouchMove.bind(this), false);
    this.element.addEventListener('touchmove', onTouchMove.bind(this), false);
    this.element.addEventListener('mouseup', onTouchEnd.bind(this), false);
    this.element.addEventListener('touchend', onTouchEnd.bind(this), false);
    this.element.addEventListener('mouseleave', onTouchEnd.bind(this), false);
    this.element.addEventListener('wheel', onWheel.bind(this), false);
  }

  /**
  * @public
  * isScrolling: returns true if a touchStart event has been triggered, otherwise false.
  */
  VerticalSwiper.prototype.isScrolling = function isScrolling() {
    return this.touchStart || this.touchStart === 0;
  };

  /**
   * @public
   * translate: moves the element in the Y axis.
   *
   * @param {number} translation pixes that are going to be moved.
   */
  VerticalSwiper.prototype.translate = function translate(translation) {
    this.translateY += translation;
    this.element.style.transform = 'translateY(' + this.translateY + 'px)';

    if (typeof this.callback === 'function') {
      this.callback(this.translateY);
    }
  };

  /**
   * @public
   * update: overrides the value of translateY property.
   *
   * @param {number} value new translate Y value.
   */
  VerticalSwiper.prototype.update = function translate(value) {
    this.translateY = value;
  };

  /**
   * @public
   * noConflict: Returns control of NewHomeSource.SampleModule to the previous script.
   */
  VerticalSwiper.noConflict = function noConflict() {
    global.NewHomeSource.VerticalSwiper = previousVerticalSwiper;
    return VerticalSwiper;
  };

  global.NewHomeSource.VerticalSwiper = VerticalSwiper;
}(window));
